import React, {FC} from 'react';

import {Trans} from '../../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {useUserTheme} from '../../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {MessageBanner} from './messageBanner';
import {MessageBannerAction} from './messageBannerAction';
import {MessageBannerActionGroup} from './messageBannerActionGroup';
import {MessageBannerTitle} from './messageBannerTitle';

/*
 * Props.
 */

interface HiddenContentMessageBannerProps {
  onShow: () => void;
  isRounded: boolean;
}

/*
 * Component.
 */

export const HiddenContentMessageBanner: FC<HiddenContentMessageBannerProps> = (props) => {
  const theme = useUserTheme();

  return (
    <MessageBanner
      color={theme.greys.shade70}
      iconName="imageSmall"
      iconColor={theme.greys.shade20}
      isRounded={props.isRounded}
    >
      <MessageBannerTitle color={theme.greys.white}>
        <Trans id="spam-title">Images are not displayed</Trans>
      </MessageBannerTitle>
      <MessageBannerActionGroup>
        <MessageBannerAction onClick={props.onShow} textColor={theme.greys.white}>
          <Trans id="spam-external-content-toggle">Display Images</Trans>
        </MessageBannerAction>
      </MessageBannerActionGroup>
    </MessageBanner>
  );
};
